/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventUnlockConditionsType } from './eventUnlockConditionsType';

/**
 * Unlock conditions for event tasks
 */
export interface EventUnlockConditions {
  type?: EventUnlockConditionsType;
  /** Task IDs required when type='specific_tasks' */
  taskIds?: string[];
}
